import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "./apiRequest";
import { isTokenExpired } from "../../Utils/Utils";
import { logOut, raiseError, response as successAction } from "../actions/action";


const getAllUsers = createAsyncThunk('/getAllUsers', async (userId, { dispatch }) => {
  if (!isTokenExpired()) {
    try {
      const response = await apiRequest.get(`/user/getAllUsers/${userId}`);
      return response.data;
    } catch {
      dispatch(raiseError("Something went wrong. please try after sometime"));
      return;
    }
  }
  dispatch(logOut());
  dispatch(raiseError("Plase login again"))
});

const toggleUserStatus = createAsyncThunk('/toggleUserStatus', async ({ userId, isActive }, { dispatch }) => {
  try {
    await apiRequest.put(`/user/${userId}/status`, { IsActive: isActive });
    dispatch(successAction(`User ${isActive ? 'activated' : 'disabled'} successfully.`));
    return { userId, isActive };
  } catch {
    dispatch(raiseError("Failed to update user status."));
    return null;
  }
});

export { getAllUsers, toggleUserStatus };